/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Comparison_Reference_AverageInputs */



/**
* | output |
* | --- |
* | "Reference average" |
*
* @param {Consumption_Comparison_Reference_AverageInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_comparison_reference_average = /** @type {((inputs?: Consumption_Comparison_Reference_AverageInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Comparison_Reference_AverageInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Reference average")
	return /** @type {LocalizedString} */ ("Moyenne de référence")
});